import { render, staticRenderFns } from "./ecommerce-product-price.vue?vue&type=template&id=f845fad2&scoped=true"
import script from "./ecommerce-product-price.vue?vue&type=script&lang=js"
export * from "./ecommerce-product-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f845fad2",
  null
  
)

export default component.exports